import * as INR from "../INR.ts";
import * as Html from "../util/Html.ts";
import ApiServer from "../ApiServer.ts";
import * as i18n from "../i18n.ts";
import * as modal from "../util/modal.ts";
import * as libLocation from "../lib/location.ts";
import * as libUrl from "../lib/url.ts";
import { PlanningDay } from "./mealplannerApi.ts";
import * as DateUtils from "../lib/DateUtils.ts"

var renewSessionUrl;
function onApiError(error){
  modal.alert("fw2.defaultError")
}


INR.onPage(INR.URL.MEALPLANNER_NC,function(){
  renewSessionUrl = libLocation.getURLParam("re");
  let
    token = libLocation.getURLParam("v");

  ApiServer.mpncshared(token,function(mealPlannerSharedBean){
    var
      dishRangeBean = mealPlannerSharedBean.range,
      settings = mealPlannerSharedBean.settings,
      dateStart = new Date(dishRangeBean.from+'T00:00:00'),
      dateRangeEnd = new Date(new Date(dishRangeBean.to+'T00:00:00').getTime()-1000),
      days = [],
      daysByKey = {};


    var
      dateCrawler = new Date(dateStart);
    while(dateCrawler<dateRangeEnd){
      var planningDay = new PlanningDay(dateCrawler,settings);
      days.push(planningDay);
      daysByKey[planningDay.key] = planningDay;
      dateCrawler.setDate(dateCrawler.getDate()+1);
    }
    document.getElementById('weekdisplay').innerHTML = DateUtils.dayRangeString(dateStart,dateRangeEnd);


    dishRangeBean.list.forEach(function(dish){
      var
        dayKey = dish.date,
        day = daysByKey[dayKey],
        slot = day.dishByType[dish.type];

      if(slot){
        day.dishes.push(dish)
        slot.push(dish);
      }

    })
    import("../mealplanner/planning.mustache").then(function(TPL){
      Html.setHtml(document.getElementById('planner-pane'),TPL,{days:days,settings:settings,viaSharing:true});
    });
  },onApiError);
});

Html.registerDom({
  ncrecipe:function(metaId){
    libLocation.goTo(libUrl.addParams("recipebox_nc.php",{v:libLocation.getURLParam("v"),metaId:metaId}))
  }
})